
import { Component, Inject, Ref, Vue } from 'vue-property-decorator';

import { DesignerElement } from '../../models/designer-element.model';
import { DesignerStateProvider } from '../../designer.provider';

@Component({
  name: 'ed-designer-canvas',
  components: {
    EdDesignerImage: () => import(/* webpackChunkName: "ed-designer-image" */ '../ed-designer-image/ed-designer-image.component.vue'),
    EdDesignerText: () => import(/* webpackChunkName: "ed-designer-text" */ '../ed-designer-text/ed-designer-text.component.vue'),
    EdDesignerRectangle: () => import(/* webpackChunkName: "ed-designer-rectangle" */ '../ed-designer-rectangle/ed-designer-rectangle.component.vue'),
  }
})
export default class EdDesignerCanvas extends Vue {
  @Ref('elementsComponents') readonly elementsComponents!: any;

  @Inject()
  readonly DesignerStateProvider: DesignerStateProvider;

  get elements(): DesignerElement[] {
    return this.DesignerStateProvider.elements;
  }

  get elementSelected() {
    return this.DesignerStateProvider.elementSelected;
  }

  clearSelection() {
    this.DesignerStateProvider.elementSelected = null;
  }
}
